import React, { useState, useEffect } from 'react';

const DecryptASCII = ({ text, speed = 20, onProgress }) => {
  const [displayText, setDisplayText] = useState('');
  const [currentOpacity, setCurrentOpacity] = useState(0.3);
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@#$%&*!?/\\|-_=+';

  useEffect(() => {
    let iteration = 0;
    const textLength = text.length;
    
    const interval = setInterval(() => {
      const progress = iteration / textLength;
      
      // Update opacity based on progress
      setCurrentOpacity(0.3 + (progress * 0.7));
      
      // Report progress to parent if callback provided
      if (onProgress) {
        onProgress(progress);
      }
      
      setDisplayText(
        text
          .split('')
          .map((char, index) => {
            // Mantener espacios y saltos de línea
            if (char === ' ' || char === '\n') return char;
            
            if (index < iteration) {
              return text[index];
            }
            
            // Generar caracteres random similares al ASCII art
            return characters[Math.floor(Math.random() * characters.length)];
          })
          .join('')
      );

      if (iteration >= textLength) {
        clearInterval(interval);
        setCurrentOpacity(1);
      }

      iteration += textLength / 60; // Controlar velocidad
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed, onProgress]);

  return (
    <pre 
      className="ascii-art ascii-decrypt" 
      style={{ 
        opacity: currentOpacity,
        transition: 'opacity 0.1s ease-out',
        textShadow: `0 0 1px rgba(242, 245, 251, ${currentOpacity * 0.5}), 0 0 ${16 * currentOpacity}px rgba(176, 107, 255, ${currentOpacity * 0.3})`
      }}
    >
      {displayText}
    </pre>
  );
};

export default DecryptASCII;
